import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { DeviceInfo } from "@/interface/deviceInfo";
import { CategoryState } from "@/components/CategoryPage/redux/types";

const selectCategory = (state: RootState): CategoryState => state?.category;

export default createDraftSafeSelector(selectCategory, (category: CategoryState): DeviceInfo => category.ua);
